var docsProUploader = function(options){
	var self = this
	this.formSelector = '[data-docsUploader]'
	this.docTypeSelector = '[data-docsUploader] [data-docType]'
	this.anversoSelector = '[data-docsUploader] #localUploadFile1'
	this.reversoSelector = '[data-docsUploader] #localUploadFile2'
	this.submitBtSelector = '[data-docsUploader] [data-submit]'
	this.removeBtSelector = '[data-docs-list] [data-remove]'


	this.onAddedFileCallback = function(){}
	this.onRemovedFileCallback = function(){}
	this.onSubmitEditionCallback = function(){}
	this.onClosedCallback = function(){}
	this.submitExtraFields = {} //Si hay que pasar campos extras en el forme del submit, se añaden aquí
								//NO SE PERMITE "document", RESERVADO
	this.submitRemovalExtraFields = {} 	//Si hay que pasar campos extras en el forme del submit para removal, se añaden aquí
										//NO SE PERMITE "id", RESERVADO

	this.modalSelector = '[data-reveal-source="addDoc"]'
	this.modalAdjustSelector = '[data-reveal-source="docsAdjuster"]'
	this.expiration = {
		expDaySelector :	"[data-docsUploader] #docExpiration_day",
		expMonthSelector : "[data-docsUploader] #docExpiration_month",
		expYearSelector :	"[data-docsUploader] #docExpiration_year",
		expDay:null,
		expMonth:null,
		expYear:null
	}

	this.maxSize = 5000000 //en bytes
	this.outputCompression = 1.0;
	this.statusMsg = {};
	this.statusMsg.selector="[data-docsUploader] [data-status-msg]";
	this.statusMsg.okClasses="success";
	this.statusMsg.koClasses="alert";
	this.strings = {
		sizeExceeds:"El tamaño del fichero excede de:",
		incomplete:"Error: Faltan datos por rellenar o ficheros por adjuntar.",
		ok:"OK, finalizando...",
		confirm:"¿Seguro que deseas eliminar el documento? Tendrás que añadirlo de nuevo.",
		caducidad:"Caducidad",
		fechaSubida:"Fecha de carga",
		waitingForApproval:"Recibido. Pendiente de verificación",
		send:"Enviar documento"
	}
	this.statusTypesStr = {
		0:"",
		1:"Aprobado",
		2:"Verificando",
		3:"Denegado",
		4:"Caducado"
	}
	this.statusTypesStrClasses = {
		0:"",
		1:"is-active",
		2:"on-hold",
		3:"denied",
		4:"denied"
	}

	this.statusMsgDelete = {};
	this.statusMsgDelete.selector="[data-status-msg]#removalError";
	this.statusMsgDelete.okClasses="success";
	this.statusMsgDelete.koClasses="alert";

	this.sendDataURL = "/data/?action=docUpload";
	this.sendDeleteURL = "/data/?action=docDelete";
	this.docsList = new Array();
	this.typeList = {
		1:{ name:"Documento de Identidad",hasReverso: true,hasExpiration: true,expirationString:"Fecha de caducidad"},
		2:{ name:"Carnet de Conducir",hasReverso: false,hasExpiration: true,expirationString:"Fecha de caducidad"},
		3:{ name:"Pasaporte", hasReverso: false,hasExpiration: true, expirationString:"Fecha de caducidad"},
		4:{ name: "Origen de ingresos", hasReverso: false,hasExpiration: false},
		5:{ name: "Origen de los fondos", hasReverso: false,hasExpiration: true, expirationString:"Fecha de caducidad"},
		6:{ name: "Foto tarjeta de crédito", hasReverso: false,hasExpiration: true}, expirationString:"Fecha de caducidad",
		7:{ name: "Certificado cuenta bancaria", hasReverso: false,hasExpiration: true, expirationString:"Fecha de caducidad"},
		99:{ name: "Otro documento", hasReverso: false,hasExpiration: false}
	}

/* 	typeList: {
		1: { 
			name:"Documento de Identidad",
			hasReverso: true,						//true|false
			hasExpiration: true,					//true|false|optional
			expirationString:"Fecha de caducidad",
			additional:	{ 
				new Array(
					{
						type: "IBAN",				//iIBAN|SWIFT|ADDITIONALBANKINFO
						required: true				//true|false|optional
					},
					{
						type: "SWIFT",
						required: true	
					} ...
				)
			}	
		}
	} */
	this.currentType = null

/*	var docsListSample =
	{
		id:null,
		docType:0,
		status:0, 	0 inexistent | 1 approved | 2 on hold | 3 denied
		deletable:0, si se puede borrar o no
		expiration:{
			day: 	this.expiration.expDay,
			month:	this.expiration.expMonth,
			year:	this.expiration.expYear,
		},
		uploadDate:{
			day: 	null,
			month:	null,
			year:	null,
		},
		additionalFields:{
			key:value,
			key1:value1,
			key2:value2
		},
		file: new Array(){
			{0:file1},
			{1:file2},
			{2:file3}
		}
	}
*/

	this.filesTemp = new Array()
/*
	{0:file1},
	{1:file2},
	{2:file3}
*/
	this.additionalProperties = {} 	//Propiedades adicionales que se van a pasar al forme al subir el documento
									//Se establece con setAdditionalProperties();

	if(typeof options != "undefined"){
		if(typeof options.docsList != "undefined"){
			this.docsList =  options.docsList
		}
		if(typeof options.typeList != "undefined"){
			this.typeList =  options.typeList
		}
		if( typeof options.modalSelector   != "undefined"){ this.modalSelector = options.modalSelector }
		if( typeof options.statusMsg != "undefined") {
			if( typeof options.statusMsg.selector   != "undefined"){ this.statusMsg.elem = options.statusMsg.elem }
			if( typeof options.statusMsg.okClasses	!= "undefined"){ this.statusMsg.okClasses = options.statusMsg.okClasses }
			if( typeof options.statusMsg.koClasses	!= "undefined"){ this.statusMsg.koClasses = options.statusMsg.koClasses }
		}
		if( typeof options.statusMsgDelete != "undefined") {
			if( typeof options.statusMsgDelete.selector   != "undefined"){ this.statusMsgDelete.elem = options.statusMsgDelete.elem }
			if( typeof options.statusMsgDelete.okClasses	!= "undefined"){ this.statusMsgDelete.okClasses = options.statusMsgDelete.okClasses }
			if( typeof options.statusMsgDelete.koClasses	!= "undefined"){ this.statusMsgDelete.koClasses = options.statusMsgDelete.koClasses }
		}

		if( typeof options.strings != "undefined"){
			if( typeof options.strings.sizeExceeds 	!= "undefined"){ this.strings.sizeExceeds = options.strings.sizeExceeds}
			if( typeof options.strings.incomplete 	!= "undefined"){ this.strings.incomplete = options.strings.incomplete}
			if( typeof options.strings.ok 	!= "undefined"){ this.strings.ok = options.strings.ok}
			if( typeof options.strings.confirm 	!= "undefined"){ this.strings.confirm = options.strings.confirm}
			if( typeof options.strings.caducidad 	!= "undefined"){ this.strings.caducidad = options.strings.caducidad}
			if( typeof options.strings.fechaSubida 	!= "undefined"){ this.strings.fechaSubida = options.strings.fechaSubida}
			if( typeof options.strings.waitingForApproval 	!= "undefined"){ this.strings.waitingForApproval = options.strings.waitingForApproval}
			if( typeof options.strings.send 	!= "undefined"){ this.strings.send = options.strings.send}
		}

		if( typeof options.expiration != "undefined"){
			if( typeof options.expiration.expDaySelector 	!= "undefined"){ this.expiration.expDaySelector 	= options.expiration.expDaySelector}
			if( typeof options.expiration.expMonthSelector 	!= "undefined"){ this.expiration.expMonthSelector 	= options.expiration.expMonthSelector}
			if( typeof options.expiration.expYearSelector 	!= "undefined"){ this.expiration.expYearSelector		= options.expiration.expYearSelector}
		}

		if( typeof options.submitBtSelector   != "undefined"){ this.submitBtSelector = options.submitBtSelector }
		if( typeof options.onAddedFileCallback   != "undefined"){ this.onAddedFileCallback = options.onAddedFileCallback }
		if( typeof options.onRemovedFileCallback   != "undefined"){ this.onRemovedFileCallback = options.onRemovedFileCallback}
		if( typeof options.onSubmitEditionCallback   != "undefined"){ this.onSubmitEditionCallback = options.onSubmitEditionCallback}
		if( typeof options.onClosedCallback   != "undefined"){ this.onClosedCallback = options.onClosedCallback}

		if( typeof options.statusTypesStr != "undefined"){
			if( typeof options.statusTypesStr[0] 	!= "undefined"){ this.statusTypesStr[0] = options.statusTypesStr[0]}
			if( typeof options.statusTypesStr[1] 	!= "undefined"){ this.statusTypesStr[1] = options.statusTypesStr[1]}
			if( typeof options.statusTypesStr[2] 	!= "undefined"){ this.statusTypesStr[2] = options.statusTypesStr[2]}
			if( typeof options.statusTypesStr[3] 	!= "undefined"){ this.statusTypesStr[3] = options.statusTypesStr[3]}
			if( typeof options.statusTypesStr[4] 	!= "undefined"){ this.statusTypesStr[4] = options.statusTypesStr[4]}

		}

		if(typeof options.submitExtraFields != "undefined"){ this.submitExtraFields = options.submitExtraFields }
		if(typeof options.submitRemovalExtraFields != "undefined"){ this.submitRemovalExtraFields = options.submitRemovalExtraFields }

		if(typeof options.sendDataURL != "undefined"){ this.sendDataURL = options.sendDataURL }
		if(typeof options.sendDeleteURL != "undefined"){ this.sendDeleteURL = options.sendDeleteURL }
		if(typeof options.maxFileSize != "undefined"){ this.maxSize = options.maxFileSize; }
		if(typeof options.outputCompression != "undefined"){ this.outputCompression = options.outputCompression; }
		
	}

	/***********/
	/* EVENTOS */
	/***********/

	var elem = this.docTypeSelector
	$(document).off("change",elem).on("change",elem,function(){

		if($(this).val().length > 0){
			$(self.anversoSelector).removeAttr('disabled')
			$('[data-anverso]').removeClass('disabled')
			$('[data-expiration-form]').removeClass('disabled')
			
			if( self.typeList[$(this).val()].hasReverso == false){
				$(self.reversoSelector).attr('disabled','disabled')
				$('[data-reverso]').addClass('disabled')
			}else{
				$(self.reversoSelector).removeAttr('disabled')
				$('[data-reverso]').removeClass('disabled')
			}
			
			if( self.typeList[$(this).val()].hasExpiration === false){
				$('[data-expiration-form] #docExpiration_day').add('[data-expiration-form] #docExpiration_month').add('[data-expiration-form] #docExpiration_year').attr('disabled','disabled').attr('data-abide-ignore','');
				$('[data-expiration-form]').addClass('disabled')
				self.expiration.expDay = null;
				self.expiration.expYear = null;
				self.expiration.expMonth = null;
				$('[data-expiration-form] #docExpiration_day option').eq(0).prop('selected',true)
				$('[data-expiration-form] #docExpiration_month option').eq(0).prop('selected',true)
				$('[data-expiration-form] #docExpiration_year option').eq(0).prop('selected',true)
			}else{
				$('[data-expiration-form] #docExpiration_day').add('[data-expiration-form] #docExpiration_month').add('[data-expiration-form] #docExpiration_year').removeAttr('disabled').removeAttr('data-abide-ignore');
				$('[data-expiration-form]').removeClass('disabled')
			}			
			$(self.formSelector).find('[data-scheme]').removeClass('is-active');
			if( typeof self.typeList[$(this).val()].additional != "undefined"){
				$(self.typeList[$(this).val()].additional).each(function(k,v){
					
					switch(v.type){
						case "IBAN":
							var schemeElem = $(self.formSelector).find('[data-scheme = "IBAN"]');
							$(schemeElem).addClass('is-active');
							if(v.required){
								$(schemeElem).find('[data-field="iban"]').removeAttr('data-abide-ignore')
							}
						break;
						case "SWIFT":
							var schemeElem = $(self.formSelector).find('[data-scheme = "SWIFT"]');
							$(schemeElem).addClass('is-active');
							if(v.required){
								$(schemeElem).find('[data-field="bic"]').removeAttr('data-abide-ignore')
							}							
						break;
						case "ADDITIONALBANKINFO":
							var schemeElem = $(self.formSelector).find('[data-scheme = "ADDITIONALBANKINFO"]');
							$(schemeElem).addClass('is-active');
							if(v.required){
								$(schemeElem).find('[data-field="bank_clabe"]').removeAttr('data-abide-ignore')
							}
						break;						
					}

				})
			}

		}else{
			$(self.anversoSelector).attr('disabled','disabled')
			$('[data-anverso]').addClass('disabled')
			$('[data-expiration-form] #docExpiration_day').add('[data-expiration-form] #docExpiration_month').add('[data-expiration-form] #docExpiration_year').attr('disabled','disabled').attr('data-abide-ignore','');
			$('[data-expiration-form]').addClass('disabled')
		}
	})

	$(document).off("change",this.expiration.expDaySelector).on("change",this.expiration.expDaySelector,function(){
		if($(this).val().length != 0){ self.expiration.expDay = $(this).val() }else{ self.expiration.expDay = null }
	})
	$(document).off("change",this.expiration.expMonthSelector).on("change",this.expiration.expMonthSelector,function(){
		if($(this).val().length != 0){ self.expiration.expMonth = $(this).val() }else{ self.expiration.expMonth = null }
	})
	$(document).off("change",this.expiration.expYearSelector).on("change",this.expiration.expYearSelector,function(){
		if($(this).val().length != 0){ self.expiration.expYear = $(this).val() }else{ self.expiration.expYear = null }
	})

	$(document).off("click",this.modalSelector+" [data-core_reveal-close]").on("click",this.modalSelector+" [data-core_reveal-close]",function(){
		self.close()
	})

	$(document).off("click",this.anversoSelector + "," + this.formSelector + " " + this.reversoSelector).on("click",this.anversoSelector + "," + this.formSelector + " " + this.reversoSelector,function(){ $(this).val("")})
	$(document).off("click",this.removeBtSelector).on("click",this.removeBtSelector,function(){
		var confirmation = confirm(self.strings.confirm)
		if (confirmation){
			self.submitRemoval($(this).closest('[data-doc-id]').attr('data-doc-id'),{
				extraFields: self.submitRemovalExtraFields
			})
		}
	})
	$(document).off("change",this.anversoSelector).on("change",this.anversoSelector,function(){ 	retrImg(this,0)	})
	$(document).off("change",this.reversoSelector).on("change",this.reversoSelector,function(){ 	retrImg(this,1)	})
	$(document).off("submit",this.formSelector).on("submit",this.formSelector,function(){
		retrieveAdditionalFieds();
		self.submit({
			extraFields: self.submitExtraFields
		})
	})

	function retrImg(elem,imgStorageIndex){
		var msgElem = $(self.statusMsg.selector)
		$(msgElem).hide()
		var myPic=elem.files[0];
		var reader=new FileReader();
		reader.readAsDataURL(myPic);
		reader.onload = function(event) {
			if(event.total > self.maxSize){
				$(msgElem).html("<p>"+self.strings.sizeExceeds + " " + self.maxSize + " bytes"+"</p>").addClass(self.statusMsg.koClasses).show()
			}else{
				self.filesTemp[imgStorageIndex] = event.target.result
				markDone(imgStorageIndex,true)
				if( self.filesTemp[imgStorageIndex].substr(0,50).indexOf("application/pdf") == -1 ){
					self.openAdjuster(imgStorageIndex)
				}
			}
  		}
	}
	function markDone(imgStorageIndex,mode){
		if( imgStorageIndex == 0 ){
			var elem = $(self.formSelector).find('[data-upload-status="1"]')
		}else if( imgStorageIndex == 1 ){
			var elem = $(self.formSelector).find('[data-upload-status="2"]')
		}
		if(mode){
			$(elem).addClass('is-active')
		}else{
			$(elem).removeClass('is-active')
		}
	}

	function retrieveAdditionalFieds(){
		var elem = $(self.formSelector).find('[data-field]');
		var fieldsTmp = {}
		$(elem).each(function(k,v){
			fieldsTmp[$(v).attr('data-field')] = $(v).val();
		})
		self.additionalFields = fieldsTmp;
		return fieldsTmp;
	}

}

docsProUploader.prototype.checkValidity = function(){
	var elem = this.docTypeSelector
	if (this.typeList[$(elem).val()].hasReverso){  //si el tipo de documento tiene reverso, entonces se esperan 2 ficheros, de lo contrario se espera sólo 1
		if(this.filesTemp.length == 2){
			return true
		}else{
			return false
		}
	}else{
		if(this.filesTemp.length >= 1){
			return true
		}else{
			return false
		}
	}

}
docsProUploader.prototype.addDoc = function(docObj){
	/*
		odcObj = {
			id:0001,
			docType:0,
			expiration:123141414
		}
	*/
	var self = this
	var found = false

	//Si ya existe actualizamos
	$(this.docsList).each(function(){
		if(this.id == sansObj.docObj.id){
			this.docType = docObj.docType
			this.expiration = docObj.expiration
			if(typeof docObj.additionalFields != "undefined"){
				this.additionalFields = docObj.additionalFields;
			}
			found = true
			return false
		}
	})
	if(!found){
		this.docsList.push(docObj)
	}
}
docsProUploader.prototype.removeDoc = function(id){
	var self = this
	var i = 0

	$(this.docsList).each(function(){
		if(this.id == id){
			self.docsList.splice(i,1)
			return false
		}
		i++
	})
}
docsProUploader.prototype.getDocs = function(mode,filterByType){

	var self = this
	if(mode == "editableTable"){
		var html = ""
		$(self.docsList).each(function(k,v){
// 			var current_date=new Date(this.expiration);
// 			var formatted_date = current_date.getDate() + "/" + (parseInt(current_date.getMonth()) + 1) + "/" + current_date.getFullYear()
			if(typeof filterByType != "undefined" && filterByType != null){
				if(parseInt(filterByType) != this.docType){
					return true
				}
			}
			if(self.typeList[v.docType].hasExpiration === true){
				var formatted_date = this.expiration.day+"/"+this.expiration.month+"/"+this.expiration.year
				formatted_date = "<strong>"+self.strings.caducidad+":</strong>"+formatted_date				
			}else{
				var formatted_date = "";
			}							
			

			var upload_date = " <strong>"+self.strings.fechaSubida+":</strong>"+this.uploadDate.day+"/"+this.uploadDate.month+"/"+this.uploadDate.year
			formatted_date = "<small>"+formatted_date+upload_date+"</small>";

			var content = "<button data-reveal-params={\"id\":\""+this.id+"\"} data-reveal-source='add_doc' data-open='add_doc' type='button' >"+self.typeList[this.docType].name+formatted_date+"</button></td>"
			if(this.deletable){
				var editableHTML = '<div data-actions><button data-remove type="button"></button></div>'
			}else{
				var editableHTML = ''
			}
			var statusHTML = '<span class="'+self.statusTypesStrClasses[this.status]+'">'+self.statusTypesStr[this.status]+'</span>'
			html = html + '<tr data-doc-id="'+this.id+'"><td>'+content+'</td><td>'+statusHTML+'</td><td>'+editableHTML+'</td></tr>'
		})
		return html
	}
	if(mode == "nonEditableTable"){
		var html = ""
		$(self.docsList).each(function(){
			if(typeof filterByType != "undefined" && filterByType != null  ){
				if(parseInt(filterByType) != this.docType){
					return true
				}
			}
			
			if(self.typeList[v.docType].hasExpiration === true){
				var formatted_date = "<strong>"+self.strings.caducidad+":</strong>"+formatted_date
			}else{
				var formatted_date = "";
			}
			
			var upload_date = " <strong>"+self.strings.fechaSubida+":</strong>"+this.uploadDate.day+"/"+this.uploadDate.month+"/"+this.uploadDate.year

			var content = "<button data-reveal-params={\"id\":\""+this.id+"\"} data-reveal-source='add_doc' data-open='add_doc' type='button' title='"+self.typeList[this.docType].name+"'>"+formatted_date+"</button></td>"
			if(this.deletable){
				var editableHTML = '<div data-actions><button data-remove type="button"></button></div>'
			}else{
				var editableHTML = ''
			}
			var statusHTML = '<span class="'+self.statusTypesStrClasses[this.status]+'">'+self.statusTypesStr[this.status]+'</span>'
			html = html + '<tr data-doc-id="'+this.id+'"><td>'+content+'</td><td>'+statusHTML+'</td><td>'+editableHTML+'</td></tr>'
		})
		return html
	}else if(typeof mode == "undefined" || mode == null){
		if(typeof filterByType != "undefined" && filterByType != null  ){
			var filteredDocsList = new Array();
			$(self.docsList).each(function(){
				if(parseInt(filterByType) == this.docType){
					filteredDocsList.push(this)
				}
			})
			return filteredDocsList
		}else{
			return this.docsList
		}
	}
}
docsProUploader.prototype.open = function(typeID,showExclusive){	//Si se pasa elem, y no hay proveedor externo, marca el documento indicado en la lista. Si además showExclusive == true, SÓLO muestra ese elemento de la lista, ocultando los demás
																//Si se pasa elem y existe un proveedor externo de documentación asociado, lanza openProvider para ejecutar su código específico.
	var self = this
	var exclusiveElem = false;
	if(typeof showExclusive != "undefined" && showExclusive === true){
		exclusiveElem = true;
	}
	if(typeof typeID != "undefined"){
		var type = self.getTypeFromID(typeID);
	}else{
		var type = null;
	}

	if(type != null && typeof type.provider != "undefined" && type.provider != null){
		self.openProvider(type);
	}else{
		self.filesTemp = new Array()
		$(self.modalSelector).data('callback',function(){
			var keys = Object.keys(self.typeList)
	
			$(keys).each(function(k,v){
				var elemObj = self.typeList[v]
				if(typeof typeID != "undefined"){
					if (typeID == v){
						var selectedHTML = 'selected="selected"'
					}
					$(self.modalSelector).find('[data-docs-list] tbody').html(self.getDocs("editableTable",typeID))
				}else{
					var selectedHTML = ""
				}
				if(typeof typeID != "undefined" && ((exclusiveElem && v == typeID) || !exclusiveElem) || typeof typeID == "undefined" ){					
					$(self.docTypeSelector).append('<option value="'+v+'"'+selectedHTML+'>'+elemObj.name+'</option>')
				}
	
			})
			if(typeof typeID != "undefined"){
				$(self.docTypeSelector).trigger('change')
			}
		})
		if(typeof typeID != "undefined" && typeID != null){
			self.currentType = typeID
		}
		$(self.modalSelector).core_reveal("open")		
	}
}

docsProUploader.prototype.openProvider = function(docType){
	var self = this;
	switch (docType.provider.code){
		case "silt":
			var url = docType.provider.url;
			window.location = url;
		break;
	}
}	

docsProUploader.prototype.close = function(){
	var self = this
	self.filesTemp = new Array()
	self.currentType = null
	self.onClosedCallback(self);
	$(self.modalSelector).core_reveal("close")
}
docsProUploader.prototype.openAdjuster = function(imgStorageIndex){
	var self = this
	var imgSelector = 'img#masterImage'
	var selectionX = null
	var selectionY = null
	var selectionW 	= null
	var selectionH = null
	var imgLoader = null
	$(self.modalAdjustSelector).data('callback',function(){
		imgLoader = new loaderProObject($('#picArea'),{ enabledOnLoad:true,insertBefore:true});

		var parentObj = self
		function loadImage(src,imgSelector){
			imgLoader.destroy()

			//Codigo para el cropper alternativo
			var tmpUrl = src;
			var tmpImg = new Image;
			var realW = 0
			var realH = 0
			tmpImg.onload = function() {
			    realW = tmpImg.width
				realH = tmpImg.height
				selectionX = 0
				selectionY = 0
				selectionW = realW
				selectionH = realH
			};
			tmpImg.src = tmpUrl
			$(imgSelector).attr('src',src)
			$(imgSelector)[0].onload = function(){
				cropper = $(imgSelector).imgAreaSelect({
				    handles: true,
				    imageHeight:realH,
				    imageWidth:realW,
					onSelectEnd: function (img, selection) {
						if(selection.width > 0 && selection.height > 0){
							selectionX = selection.x1
							selectionY = selection.y1
							selectionW 	= selection.width
							selectionH = selection.height
						}
					},
					instance: true
				});


			}
		};

		function resizeImage(url, width, height, x, y, callback) {
		    var canvas = document.createElement("canvas");
		    var context = canvas.getContext('2d');
		    var imageObj = new Image();

		    // set canvas dimensions

		    canvas.width = width;
		    canvas.height = height;

		    imageObj.onload = function () {
		        context.drawImage(imageObj, x, y, width, height, 0, 0, width, height);
		        callback(canvas.toDataURL('image/jpeg',self.outputCompression));
		    };

		    imageObj.src = url;
		}

		function retrieveImg(imgSelector,callback){
			if(selectionW != null && selectionH != null && selectionX != null && selectionY != null){
				resizeImage($(imgSelector)[0].src,selectionW,selectionH,selectionX,selectionY,function(e){
					callback(e)
				})
			}
		}

		bamQueue.waitForExistance("$.imgAreaSelect",function(){
			var modalSelector = self.modalAdjustSelector
			var editSelector = imgSelector
			loadImage(self.filesTemp[imgStorageIndex],imgSelector)
			$(modalSelector).find('[data-core_reveal-close]').off('click').on('click',function(){
				$('.imgareaselect-outer').remove()
				$('.imgareaselect-selection').parent().remove()
				$(modalSelector).core_reveal('close')
			})
			$(modalSelector).find('button[data-submit]').off('click').on("click",function(){
				retrieveImg(editSelector,function(e){
					self.filesTemp[imgStorageIndex]	= e
/*
					var img = new Image;
					img.src = self.filesTemp[imgStorageIndex]
					var w = window.open("");
					w.document.write(img.outerHTML);
*/
					$('.imgareaselect-outer').remove()
					$('.imgareaselect-selection').parent().remove()
					if(imgStorageIndex == 0){
						$('[data-localUploadFile1Thumb] [data-img]').css('background-image',"url("+self.filesTemp[imgStorageIndex]+")").parent().addClass('is-active')

					}else if (imgStorageIndex == 1){
						$('[data-localUploadFile2Thumb] [data-img]').css('background-image',"url("+self.filesTemp[imgStorageIndex]+")").parent().addClass('is-active')
					}
					$(self.modalAdjustSelector).core_reveal("close")
				});
			})
		})
	})
	$(self.modalAdjustSelector).core_reveal("open")
}
docsProUploader.prototype.submit = function(options){
	var self = this
	var msgElem = $(self.statusMsg.selector)
	var extraFields = {}
	var additionalFields = {}
	if(typeof options != "undefined"){
		if(typeof options.extraFields != "undefined"){
			extraFields = options.extraFields;
		}
	}

	if(this.checkValidity()){
		$(msgElem).html("<p>"+self.strings.ok+"</p>").removeClass(self.statusMsg.koClasses).addClass(self.statusMsg.okClasses).show()
		var files = self.filesTemp
		if (!self.typeList[$(self.docTypeSelector).val()].hasReverso){ //Si no tiene reverso, solo volcamos el anverso por si se hubieran subido las dos imagenes.
			if(files.length > 1){
				files = self.filesTemp.splice(1,files.length - 1)
			}
		}
		var docsListItem = {
			id:null,
			type: $(self.docTypeSelector).val(),
			status:2,//por defecto lo ponemos on-hold
			deletable: true, //y damos el periodo de gracia en el que lo puede borrar aunque esto da igual, el servidor es el que devuelve el snapshot de la bbdd
			expiration: {
				day: 	this.expiration.expDay,
				month:	this.expiration.expMonth,
				year:	this.expiration.expYear,
			},
			uploadDate: { //Estos datos deben venir devueltos y rellenos por el servidor
				day: null,
				month: null,
				year:null
			},
			files: files
		}
		if(Object.keys(self.additionalFields).length > 0){
			docsListItem["additionalFields"] = self.additionalFields;
		}
		extraFields["document"] = docsListItem;
		extraFields["additionalProperties"] = self.additionalProperties;
		var forme = new formeSubmit(false,self.sendDataURL,{
			submitBt: {
				elem : $(self.submitBtSelector),	//default: [data-submit]
				enableOnSuccess: false				//default: false //Si se establece TRUE reactiva el botón al success.
			},
			statusMsg: {
				elem: $(self.statusMsg.selector),		//default: [data-status-msg]
			},
			callbackOnSuccess: function(e) {
				self.filesTemp = new Array() //liberamos carga

	/*
			if(typeof e.data.id != "undefined"){
					docsListItem.id = e.data.id
				}
				self.docsList.push(docsListItem)
				self.filesTemp = new Array()
				var j = {
					docID:docsListItem.id,
					docType: $(self.docTypeSelector).val()
				}
*/
				self.docsList = e.data	//tiene que devolver el ajax un snapshot del objeto con datos reales actualizados tras el añadido
				self.onAddedFileCallback(e,self);
			},
			extraFields: extraFields
		})

	}else{
		$(msgElem).html("<p>"+self.strings.incomplete+"</p>").addClass(self.statusMsg.koClasses).show()
	}
}
docsProUploader.prototype.getFiles = function(){
	return JSON.stringify(this.docsList)
}
docsProUploader.prototype.submitRemoval = function(ID,options){
	var self = this
	var extraFields = {}

	if(typeof options != "undefined"){
		if(typeof options.extraFields != "undefined"){
			extraFields = options.extraFields;
		}
	}
	extraFields["id"] = ID
	var forme = new formeSubmit(false,self.sendDeleteURL,{
		statusMsg:self.statusMsgDelete,
		callbackOnSuccess: function(e) { //tiene que devolver el ajax un snapshot del objeto con datos reales actualizados tras el borrado
// 			self.removeDoc(ID)
			self.docsList = e.data
			self.onRemovedFileCallback(e,self);
		},
		extraFields: extraFields
	})
}
docsProUploader.prototype.setOnAddedFileCallback = function(fn){
	this.onAddedFileCallback = fn;
}
docsProUploader.prototype.setOnRemovedFileCallback = function(fn){
	this.onRemovedFileCallback = fn;
}
docsProUploader.prototype.setOnClosedCallback = function(fn){
	this.onClosedCallback = fn;
}
docsProUploader.prototype.setAdditionalProperty = function(property){
	var self = this;
	self.additionalProperties = Object.assign(self.additionalProperties,property);
}
docsProUploader.prototype.getTypeFromID = function(typeID){
	var self = this;
	var types= this.getTypeList();
	var valueToReturn = false;
	$.each(types,function(key,value){
		if(key == typeID){
			valueToReturn = value;
			return false;
		}
	})
	return valueToReturn;
}
docsProUploader.prototype.getTypeList = function(){
	return this.typeList;	
}
docsProUploader.prototype.countItemsForDocType = function(docType,unique,ignoreRejected){
	//Método que devuelve cuantos items hay de cada tipo docType. DocTypes puede ser un array de tipos de documentos y devolverá cuantos hay en total de los tipos suministrados.
	//"Unique" contará solo una vez los documentos subidos del mismo tipo. 
	//Si no se pasa docType, devolverá el número total de documentos, si unique === true entonces sólo contará una vez los documentos del mismo tipo)
	//Si se usa ignoreRejected, los documentos de estado 3 o 4, no se incluirán en el recuento
	
	var isUnique=false;
	var isIgnoreRejected=false;
	var total = 0;
	var self = this;
	if(typeof unique != "undefined" && unique === true){
		isUnique = true;
	}
	if(typeof ignoreRejected != "undefined" && ignoreRejected === true){
		isIgnoreRejected = true;
	}
	
	var uniqueArray = new Array();
	
	$.each(self.docsList,function(k,v){
		if(Array.isArray(docType)){
			if(docType.indexOf(v.docType) != -1){
				if(!isUnique){
					if(!isIgnoreRejected || (isIgnoreRejected && (v.status != 3 && v.status != 4))){					
						total++;
					}
				}else{
					if(uniqueArray.indexOf(v.docType) == -1){
						if(!isIgnoreRejected || (isIgnoreRejected && (v.status != 3 && v.status != 4))){
							total++;
							uniqueArray.push(v.docType);
						}
					}
				}
			}
		}else if(typeof docType != "undefined" && docType != null){
			if(v.docType == docType){
				if(!isUnique){
					if(!isIgnoreRejected || (isIgnoreRejected && (v.status != 3 && v.status != 4))){
						total++;		
					}
				}else{
					if(uniqueArray.indexOf(v.docType) == -1){
						if(!isIgnoreRejected || (isIgnoreRejected && (v.status != 3 && v.status != 4))){
							total++;
							uniqueArray.push(v.docType);
						}
					}
				}
			}
		}else{
			//Si no pasamos el documento contamos cuantos hay
			//O cuantos hay diferentes (si unique === true)
			if(!unique){
				if(!isIgnoreRejected || (isIgnoreRejected && (v.status != 3 && v.status != 4))){
					total++;
				}
			}else{
				if(uniqueArray.indexOf(v.docType) == -1){
					if(!isIgnoreRejected || (isIgnoreRejected && (v.status != 3 && v.status != 4))){
						total++;
						uniqueArray.push(v.docType);
					}
				}				
			}
		}
	})
	return total;
}